require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-should-the-u-s-prioritize-in-the-final-months.json") })
        }
      }, "path---en-us-update-what-should-the-u-s-prioritize-in-the-final-months");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-should-the-u-s-prioritize-in-the-final-months!./.cache/json/en-us-update-what-should-the-u-s-prioritize-in-the-final-months.json
// module id = 852
// module chunks = 231608221292675